<template>
  <div class="ocr-message-container d-flex pa-5 rounded-lg">
    <app-material-icon
      class="mr-2"
      color="icon-info"
      name="info"
    />
    <div class="w-100">
      <div class="mb-0">
        <span class="body-md-bold text-text-primary">
          {{ $t('common.PdfRedactingSidebar.ocrMessage.pdfContainsNoText') }}
        </span>

        <p class="mt-2 text-text-secondary">
          {{ $t('common.PdfRedactingSidebar.ocrMessage.ocrProcessExplanation') }}
          <a class="learnMoreLink text-text-link" :href="learnMoreLink" target="_blank">
            {{ $t("common.learnMore") }}
          </a>
        </p>

        <app-button class="mt-4"
                    size="small"
                    fullWidth
                    type="outlined"
                    variant="neutral"
                    @click="$emit('launch-ocr-conversion')"
        >
          <app-material-icon name="cached" />
          {{ $t('common.PdfRedactingSidebar.ocrMessage.launchConversion') }}
        </app-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

defineEmits(['launch-ocr-conversion'])

const { t } = useI18n()

const learnMoreLink = computed(() => t('common.helpLinks.ocr'))
</script>

<style scoped lang="scss">
.ocr-message-container {
  background-color: rgb(var(--v-theme-surface-info));
}

a.learnMoreLink {
  text-decoration: underline;
}
</style>
